import { createSlice } from "@reduxjs/toolkit";

const pbRoles = [
  "FcAdmin",
  "FcSalesRep",
  "FcStoreManager",
  "FcNA",
  "FcDistrictMgr",
  "FcCityMgr",
  "FcVPS",
  "FcSuperAdmin",
];

const updateRoles = ["FcAdmin", "FcStoreManager", "FcOpsMgr", "FcSalesRep", "FcSuperAdmin"];

const userSlice = createSlice({
  name: "loggedInUser",
  initialState: {},
  reducers: {
    setUserInfo(_state, action) {
      const user = action.payload;
      return {
        ...user,
        hasPbAccess: pbRoles.includes(user?.fcRole),
        hasUpdateAccess: updateRoles.includes(user?.fcRole),
      };
    },
  },
});

export const { setUserInfo } = userSlice.actions;
export default userSlice.reducer;
